import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Resolve,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import {
  CLEAR_STATE,
  getEntityDetails,
  getSelectedOrganizationInfo,
  getSelectedSupplierId,
  setSelectedSupplier,
} from '@boma/supplier-portal/shared/state';
import { ProfileService } from '@boma/website/shared';
import { Store } from '@ngrx/store';
import { Observable, filter, map, take } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EntityResolver implements Resolve<any> {
  constructor(
    private profileService: ProfileService,
    private store: Store,
    private router: Router
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> {
    const entityId = route.params['entityId'];

    if (entityId) {
      return this.store.select(getSelectedSupplierId).pipe(
        filter((x) => !!x),
        map((x) => {
          console.log(x, entityId);
          if (x !== entityId) {
            this.profileService.switchContext(entityId);
            this.store.dispatch(new CLEAR_STATE());

            this.store.dispatch(setSelectedSupplier({ id: entityId }));
            this.store.dispatch(getEntityDetails({ id: entityId }));
            const currentUrl = state.url;
            this.router.navigateByUrl(currentUrl);
          }
        })
      );
    }
  }
}
